import Catalog from '../../../pages/catalog/Catalog.js';

export default new class Filter {
    constructor() {
        new Catalog();
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/form-search/Filter.js